import {get as _get, find as _find, random as _random} from 'lodash';

import initialState from '../initialstate';
import {
	GET_GA_SCOPES,
	GET_GA_ASSIGNED_SCOPES,
	ADD_GA_SUB_SCOPE,
	MODIFY_GA_SUB_SCOPE,
	REMOVE_GA_SUB_SCOPE,
	RESET_GA_SUB_SCOPES
} from '../../actions/actiontypes';
import {currentResource} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';
import gaAssignedScopesNormalizer from './gaAssignedScopesNormalizer';

export default function GAScopesReducer(state = initialState.gaScopes, action) {
	switch (action.type) {
		case GET_GA_SCOPES: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return data
					.filter(({isSubScope}) => !isSubScope)
					.map(({gaScopeID: id, gaScopeTypeID: type}) => ({
						id,
						type,
						label: _find(currentResource.gaScopesResource, {id: type}).label,
						subScopes: data
							.filter(({isSubScope, gaScopeTypeID: subScopeType}) => subScopeType === type && isSubScope)
							.map(({gaScopeID, gaScopeName, gaScopeTypeID, gaScopeDescription}) => ({
								id: gaScopeID,
								type: gaScopeTypeID,
								label: gaScopeName,
								description: gaScopeDescription
							}))
							.sort((a, b) => a.label.localeCompare(b.label))
					}));
			}
			return [];
		}
		case GET_GA_ASSIGNED_SCOPES: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return gaAssignedScopesNormalizer(data);
			}
			return [];
		}
		case ADD_GA_SUB_SCOPE: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Created) {
				const createdSubScope = _get(action, 'response', null);
				if (createdSubScope !== null) {
					return [...state].map((scope) => {
						const {
							gaScopeTypeID,
							gaScopeID: id,
							gaScopeName: label,
							gaScopeDescription: description,
							gaScopeTypeID: type
						} = createdSubScope;
						if (scope.type === gaScopeTypeID) {
							return {
								...scope,
								subScopes: [
									...scope.subScopes,
									{
										id,
										label,
										description,
										type
									}
								]
							};
						}
						return scope;
					});
				}
			}
			return state;
		}
		case MODIFY_GA_SUB_SCOPE: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const modifiedSubScope = _get(action, 'response', null);
				if (modifiedSubScope !== null) {
					return [...state].map((scope) => {
						const {
							gaScopeTypeID,
							gaScopeID: id,
							gaScopeName: label,
							gaScopeDescription: description,
							gaScopeTypeID: type
						} = modifiedSubScope;
						if (scope.type === gaScopeTypeID) {
							return {
								...scope,
								subScopes: scope.subScopes.map((subScope) =>
									subScope.id === id ? {id, label, description, type} : subScope
								)
							};
						}
						return scope;
					});
				}
			}
			return state;
		}
		case REMOVE_GA_SUB_SCOPE: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.NoContent) {
				const removedSubScope = _get(action, 'payload', null);
				if (removedSubScope !== null) {
					return [...state].map((scope) => {
						const {gaScopeID: id, gaScopeTypeID: type} = removedSubScope;
						if (scope.type === type) {
							return {
								...scope,
								subScopes: scope.subScopes.filter((subScope) => subScope.id !== id)
							};
						}
						return scope;
					});
				}
			}
			return state;
		}
		case RESET_GA_SUB_SCOPES: {
			return initialState.gaScopes;
		}
		default:
			return state;
	}
}
